export default __webpack_public_path__ + "static/Simon-80f7f5cda53bfdaa849d5d36ade44772.webp";